import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * Definición para que la clase sea vista desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var PlatformEndpointService = /** @class */ (function () {
    /**
     * Constructor de la clase
     * *Class Contstructor.*
     *
     * Inicializa los métodos para los modelos
     *
     * *Initialize method for models*
     *
     * @param {HttpClient} _http
     */
    function PlatformEndpointService(_http) {
        this._http = _http;
        /**
         * Varialbe para guardar la ubicación de endpoints especificos (./assets/resources/context.urls.json)
         *
         * *Variable to save location of endpoints (./assets/resources/context.urls.json) *
         *
         * @type {private}
         * @type {string} DEFAULT_URL_PATH
         */
        this.DEFAULT_URL_PATH = './assets/resources/context.urls.json';
    }
    /**
     * Función asincróna para cargar los urls de DEFAULT_URL_PATH
     *
     * *Async function to load urls inside DEFAULT_URL_PATH*
     *
     * @type {public}
     * @type {string} DEFAULT_URL_PATH
     */
    PlatformEndpointService.prototype.loadURLS = function (contextURLPath) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (contextURLPath === undefined) {
                            url = this.DEFAULT_URL_PATH;
                        }
                        else {
                            url = contextURLPath;
                        }
                        return [4 /*yield*/, this._http.get(url).toPromise().then(function (response) {
                                _this.URLS = response['URLS'];
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlatformEndpointService.prototype.loadMICRO = function (contextURLPath) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (contextURLPath === undefined) {
                            url = this.DEFAULT_URL_PATH;
                        }
                        else {
                            url = contextURLPath;
                        }
                        return [4 /*yield*/, this._http.get(url).toPromise().then(function (response) {
                                _this.MICROFRONTENDS = response['MICROFRONTENDS'];
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PlatformEndpointService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlatformEndpointService_Factory() { return new PlatformEndpointService(i0.ɵɵinject(i1.HttpClient)); }, token: PlatformEndpointService, providedIn: "root" });
    return PlatformEndpointService;
}());
export { PlatformEndpointService };
